<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('animales')">Animales</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      Vacunas
      <span class="text-gray-500 text-base font-normal ml-2">
        ({{ animal.arete }} - {{ animal.nombre }})
      </span>
    </h1>

    <div class="mb-6 flex justify-between items-center">
     

      <div class="flex gap-2">
        <inertia-link class="btn-indigo" :href="route('animales.edit', animal.id)">
          <span>Volver</span>
          <span class="hidden md:inline">Animal</span>
        </inertia-link>

        <button class="btn-indigo" type="button" @click="openModal = true">
          <span>Registrar</span>
          <span class="hidden md:inline">Vacuna</span>
        </button>
      </div>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Fecha</th>
          <th class="px-6 pt-6 pb-4">Vacuna</th>
          <th class="px-6 pt-6 pb-4">Dosis</th>
          <th class="px-6 pt-6 pb-4">Lote</th>
          <th class="px-6 pt-6 pb-4">Laboratorio</th>
          <th class="px-6 pt-6 pb-4">Próxima</th>
          <th class="px-6 pt-6 pb-4">Costo</th>
        </tr>

        <tr v-for="v in vacunas.data" :key="v.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t px-6 py-4">{{ v.fecha_aplicacion }}</td>
          <td class="border-t px-6 py-4">{{ v.vacuna }}</td>
          <td class="border-t px-6 py-4">{{ v.dosis || '-' }}</td>
          <td class="border-t px-6 py-4">{{ v.lote || '-' }}</td>
          <td class="border-t px-6 py-4">{{ v.laboratorio || '-' }}</td>
          <td class="border-t px-6 py-4">{{ v.proxima_fecha || '-' }}</td>
          <td class="border-t px-6 py-4">{{ v.costo != null ? v.costo : '-' }}</td>
        </tr>

        <tr v-if="vacunas.data.length === 0">
          <td class="border-t px-6 py-4" colspan="7">No hay vacunas registradas</td>
        </tr>
      </table>
    </div>

    <pagination class="mt-6" :links="vacunas.links" />

  <!-- MODAL REGISTRAR VACUNA (degradado + blur suave) -->
<div v-if="openModal" class="fixed inset-0 z-50 flex items-center justify-center px-4">
  <!-- Overlay: oscuro con degradado -->
  <div
    class="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/60 opacity-100"
    @click="closeModal"
  ></div>

  <!-- (Opcional) si tu Tailwind lo soporta, agrega blur:
       class="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/60 backdrop-blur-[1px]"
  -->

  <!-- Modal -->
  <div class="relative bg-white rounded-md shadow-xl overflow-hidden w-full max-w-3xl">
    <div class="px-8 py-4 bg-gray-50 border-b border-gray-100 flex justify-between items-center">
      <div class="font-bold">Registrar Vacuna</div>
      <button type="button" class="text-gray-500 hover:text-gray-800" @click="closeModal">✕</button>
    </div>

    <!-- Scroll si el contenido crece -->
    <div class="max-h-[80vh] overflow-y-auto">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="vacunaForm.fecha_aplicacion" :error="vacunaForm.errors.fecha_aplicacion"
            class="pr-6 pb-8 w-full lg:w-1/3" label="Fecha" type="date" required />

          <text-input v-model="vacunaForm.vacuna" :error="vacunaForm.errors.vacuna"
            class="pr-6 pb-8 w-full lg:w-2/3" label="Vacuna" required />

          <text-input v-model="vacunaForm.dosis" :error="vacunaForm.errors.dosis"
            class="pr-6 pb-8 w-full lg:w-1/3" label="Dosis" />

          <text-input v-model="vacunaForm.lote" :error="vacunaForm.errors.lote"
            class="pr-6 pb-8 w-full lg:w-1/3" label="Lote" />

          <text-input v-model="vacunaForm.laboratorio" :error="vacunaForm.errors.laboratorio"
            class="pr-6 pb-8 w-full lg:w-1/3" label="Laboratorio" />

          <text-input v-model="vacunaForm.proxima_fecha" :error="vacunaForm.errors.proxima_fecha"
            class="pr-6 pb-8 w-full lg:w-1/3" label="Próxima Fecha" type="date" />

          <text-input v-model="vacunaForm.costo" :error="vacunaForm.errors.costo"
            class="pr-6 pb-8 w-full lg:w-1/3" label="Costo" type="decimal" />

          <text-input v-model="vacunaForm.observacion" :error="vacunaForm.errors.observacion"
            class="pr-6 pb-8 w-full" label="Observación" />
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="vacunaForm.processing" class="btn-indigo" type="submit">
            Guardar Vacuna
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</div>

  </div>
</template>

<script>
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Vacunas' },
  components: {
    Pagination,
    SearchFilter,
    TextInput,
    LoadingButton,
  },
  layout: Layout,
  props: {
    animal: Object,
    filters: Object,
    vacunas: Object,
  },
  data() {
    return {
      openModal: false,
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
      vacunaForm: this.$inertia.form({
        fecha_aplicacion: null,
        vacuna: null,
        dosis: null,
        lote: null,
        laboratorio: null,
        proxima_fecha: null,
        costo: null,
        observacion: null,
      }),
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        // Mantiene tu estilo: filtra por query en la misma pantalla
        this.$inertia.get(
          this.route('animales.vacunas', { animal: this.animal.id }),
          pickBy(this.form),
          { preserveState: true }
        )
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    closeModal() {
      this.openModal = false
      this.vacunaForm.clearErrors()
    },
    store() {
      this.vacunaForm.post(this.route('animales.vacunas.store', { animal: this.animal.id }), {
        preserveScroll: true,
        onSuccess: () => {
          this.openModal = false
          this.vacunaForm.reset()
        },
      })
    },
  },
}
</script>